<template>
  <div class="login">
    <div class="login-box">
       <div class="login-head">
         <Head></Head>
       </div>
       <!-- <div class="login-h3" v-if="this.$route.query.type == 'fukuan'">
          <h3>依照国家规定，您的个人账户如有信息需要完善，请尽快完善信息。<a @click="()=>{this.$router.push('/personalCenter/personalinfo')}">点击这里</a>去完善。您的注册账户通过审核后我们会立即发货。如需帮助，请致电400-088-0777。</h3>
       </div> -->
       <div class="login-main" v-if="this.$route.query.type == 'dingdan'">
           <img src="@/assets/success.jpg" alt=""><span>已生成订单<a class="active" @click="orderList">点击查看</a> </span>
       </div>
       <div class="login-main" v-if="this.$route.query.type == 'forget'">
           <img src="@/assets/success.jpg" alt=""><span>请在邮箱中进行<span class="jihuo">激活</span>后登录<a class="active"></a> </span>
       </div>
        <div class="login-main" v-if="this.$route.query.type == 'register'">
           <img src="@/assets/success.jpg" alt=""><span>请在邮箱中进行<span class="jihuo">激活</span>后登录<a class="active"></a> </span>
       </div>
       <div class="login-main" v-if="this.$route.query.type == 'fukuan'">
          <img src="@/assets/success.jpg" alt=""><span>付款成功<a class="active" @click="lookOrder()">查看订单</a></span>
       </div>
       <div class="login-main" v-if="this.$route.query.type == 'tryOut'">
          <img src="@/assets/success.jpg" alt=""><span>已生成订单点击查看<a class="active" @click="tryOrderList">查看订单</a></span>
       </div>
    </div>
  </div>
</template>

<script>
import Head from "./components/submitHead"
export default {
  components:{
    Head
  },
  data(){
   return{
     type:this.$route.query.type
   }
  },
    methods: {
        orderList(){
          this.$router.push("/personalCenter/orderCenter");
        },
        lookOrder(){
          this.$router.push("/personalCenter/orderCenter");
        },
        tryOrderList(){
          this.$router.push("/personalCenter/tryOrderCenter");
        },
        open() {
        this.$confirm(`依照国家规定，您的个人信息如有信息需要完善，请尽快完善信息，您的注册账户通过审核后我们会立即发货。如需帮助，请致电400-088-0777。`, '温馨提示', {
          confirmButtonText: '立即完善',
          cancelButtonText: '稍后完善',
          type: 'warning',
          center: true
        }).then(() => {
          this.$router.push('/personalCenter/personalinfo')
        }).catch(() => {
         
        });
      }
    },
    created(){
      if(this.$route.query.type == 'forget' || this.$route.query.type == 'register'){
        
      }else{
        this.open()
      }
    }
}
</script>

<style lang="less" scoped>
/deep/.el-message-box__message {
  p{
    font-size: 16px !important;
    font-weight: 600;
  }
}
/deep/.el-button--primary {
  background-color: #003871 !important;
}
.jihuo{
  color:red
}
.login{
  width: 1920px;
  height:100vh;
  background: url("http://office.bioleaper.com.cn:6681/static/images/bg-login.jpg") no-repeat;
  background-size: 100% 100%;
  position: relative;
  .login-box{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    height:908px;
    width: 1200px;
    background: #fff;
    border-radius: 9px 9px 0px 0px;
    .login-head{
      width: 1200px;
      height:117px;
    }
   .login-h3{
     font-size: 14px;
   }
 .login-main{
      width: 553px;
      height: 300px;
      color: #333333;
      margin-left: 300px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 150px;
      span{
          text-align: center;
          margin-top: 30px;
          font-size:30px;
          a{
             font-style: normal;
             color: #ffbb00;
          }
      }
      .icon-span{
        display: inline-block;
        background-color: #fff;
        border-radius: 100%;
        border: 1px solid #ccc;
        position: relative;
        width: 150px;
        height: 150px;
        vertical-align: middle;
    }
    .icon-span::after{
    border: 2px solid transparent;
    border-left: 0;
    border-top: 0;
        content: " ";
        top: 20px;
        left: 36px;
        font-weight: 700;
        position: absolute;
        width: 80px;
        height: 86px;
        -webkit-transform: rotate(45deg) scale(0);
        transform: rotate(45deg) scale(0);
        -webkit-transition: -webkit-transform .2s;
        transition: -webkit-transform .2s;
        transition: transform .2s;
        transition: transform .2s, -webkit-transform .2s;
        }
        .icon-span{
        background-color: green;
        border-color: #fff;
        }
        .icon-span::after{
        border-color: #fff;
        -webkit-transform: rotate(45deg) scale(1);
        transform: rotate(45deg) scale(1);
        }
    }
  }
}
.register{
  width: 1920px;
  height:100vh;
  background: #ccc;
  position: relative;
  .register-box{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    height:908px;
    width: 1200px;
    background: #fff;
    border-radius: 9px 9px 0px 0px;
    .register-head{
      width: 1200px;
      height:117px;
    }
    .register-main{
      width: 553px;
      height: 300px;
      color: #333333;
      margin-left: 300px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 150px;
      span{
          text-align: center;
          margin-top: 30px;
          font-size:30px;
          a{
             font-style: normal;
             color: #ffbb00;
          }
      }
      .icon-span{
        display: inline-block;
        background-color: #fff;
        border-radius: 100%;
        border: 1px solid #ccc;
        position: relative;
        width: 150px;
        height: 150px;
        vertical-align: middle;
    }
    .icon-span::after{
    border: 2px solid transparent;
    border-left: 0;
    border-top: 0;
        content: " ";
        top: 20px;
        left: 36px;
        font-weight: 700;
        position: absolute;
        width: 80px;
        height: 86px;
        -webkit-transform: rotate(45deg) scale(0);
        transform: rotate(45deg) scale(0);
        -webkit-transition: -webkit-transform .2s;
        transition: -webkit-transform .2s;
        transition: transform .2s;
        transition: transform .2s, -webkit-transform .2s;
        }
        .icon-span{
        background-color: green;
        border-color: #fff;
        }
        .icon-span::after{
        border-color: #fff;
        -webkit-transform: rotate(45deg) scale(1);
        transform: rotate(45deg) scale(1);
        }
    }
  }
}
</style>